import { FASTElement as d, observable as p, attr as n } from "@microsoft/fast-element";
import { timerStyles as c } from "./timer.styles.js";
import { timerTemplate as f } from "./timer.template.js";
import { NumberStringConverter as v } from "../common/converters/number-string-converter.js";
import { toRem as u } from "../common/css-utils.js";
var y = Object.defineProperty, s = (h, t, r, m) => {
  for (var e = void 0, a = h.length - 1, l; a >= 0; a--)
    (l = h[a]) && (e = l(t, r, e) || e);
  return e && y(t, r, e), e;
};
const o = class o extends d {
  constructor() {
    super(...arguments), this._time = 0, this.duration = 0, this.start = !1;
  }
  sizeChanged() {
    this.invalidateSize(1.5), this.style.width = this.size, this.style.height = this.size;
  }
  invalidateSize(t) {
    this.size || (this.size = u(t));
  }
  startChanged() {
    this.isConnected && this.start && this.startTimer();
  }
  durationChanged() {
    this.isConnected && (this._time = Math.floor(this.duration / 1e3), this.style.setProperty("--nova-timer-percentage", "1"), this._timer && (clearInterval(this._timer), this._timer = void 0));
  }
  connectedCallback() {
    super.connectedCallback(), this.invalidateSize(1.5), this.start && this.startTimer();
  }
  startTimer() {
    let t = this.duration;
    const r = 1e3 / 60;
    return new Promise((m) => {
      this._timer = window.setInterval(() => {
        t -= r, this._time = Math.ceil(t / 1e3);
        const e = t / this.duration;
        this.style.setProperty(
          "--nova-timer-percentage",
          e.toString()
        ), t <= 0 && (clearInterval(this._timer), this._timer = void 0, this._time = -1, this.style.setProperty("--nova-timer-percentage", "0"), m(), this.$emit("finished", null, {
          cancelable: !1
        }));
      }, r);
    });
  }
};
o.definition = {
  name: "timer",
  template: () => f,
  styles: () => c
};
let i = o;
s([
  p
], i.prototype, "_time");
s([
  n({ converter: v })
], i.prototype, "duration");
s([
  n({ mode: "boolean" })
], i.prototype, "start");
s([
  n
], i.prototype, "size");
export {
  i as Timer
};
